import React from 'react';
import Rental from './Rental';
import moment from 'moment-timezone';
import {
  nestedStateForRailsWithConversion,
  prepopulateArray,
} from 'HelperFunctions/formHelpers';
import { connect } from 'react-redux';
import * as actions from 'Actions';
import LoadingSpinner from 'Utils/LoadingSpinner';
import axios from 'axios';
import { objectToFormData } from 'HelperFunctions/formHelpers';
import Modal from 'Utils/Modal';
import { FormattedDate } from 'react-intl';
import classNames from 'classnames';
import CurrencyLabel from 'Utils/CurrencyLabel';
import converter from 'json-style-converter/es5';
import { getDisclaimersSignatures } from 'HelperFunctions/disclaimers';
import { getSignatureFromRental } from 'HelperFunctions/rentalSignature';

class GuestCheckout extends React.Component {
  constructor(props) {
    super(props);
    const initialState = Object.assign({
      cancelModalOpen: false,
      tab: 0,
      rental: {},
      loaded: false,
      hours: 0,
      name: '',
      status: '',
      schedule_id: '',
      checkout: null,
      checkoutWindowEnd: null,
      checkout_time: null,
      checkin: null,
      checkinWindowStart: null,
      checkin_time: null,
      event_start: null,
      event_start_time: null,
      event_end: null,
      event_end_time: null,
      taxExempt: false,
      depositRequired: false,
      signatureRequired: false,
      npsRequired: false,
      hasAgreement: true,
      manualDamageWaiver: false,
      depositType: 'optional',
      expireType: 'no_expire',
      customExpireDate: null,
      delivery_cost: '',
      delivery_type: 'select_a_delivery_method',
      delivery_address_location_name: '',
      delivery_address_street_address_1: '',
      delivery_address_street_address_2: '',
      delivery_address_city: '',
      delivery_address_locale: '',
      delivery_address_postal_code: '',
      delivery_address_country: '',
      shouldRecalcDelivery: true,
      additionalOrderInfo: '',
      additionalDeliveryInfo: '',
      fees: [],
      last_fee_id: 0,
      expenses: [],
      last_expense_id: 0,
      notes: [],
      last_note_id: 0,

      customers: [],
      last_customer_id: 0,

      discounts: [],
      last_discount_id: 0,

      items: [],
      last_item_id: 0,

      rentalAccessories: [],
      last_rental_accessory_id: 0,

      rentalAddOns: [],
      last_rental_add_on_id: 0,

      rentalBundles: [],
      last_rental_bundle_id: 0,

      documents: [],
      last_document_id: 0,
      employee_rental_relationship: null,
      damage_waiver_fee_total: 0,
      templateOpen: false,
      customersOpen: false,
      discountsOpen: false,
      salespersonOpen: false,
      venueOpen: false,
      companyOpen: false,
      accessoriesOpen: false,
      addOnsOpen: false,
      itemsOpen: false,
      bundlesOpen: false,
      taxExemptDialogOpen: false,
      width: 400,
      canLeave: true,
      sameAsEventDates: false,
      paymentOpen: false,
      documentModalOpen: false,
      signModalOpen: false,
      successOpen: false,
      successTransaction: {},
    });
    this.state = initialState;
  }

  componentDidMount() {
    this.fillNewRentalData(this.props.rental);
  }

  refreshRental = () => {
    const { rental } = this.props;
    this.prepopulateRental(rental.token);
  };

  prepopulateRental = (id) => {
    const { openLoadingSpinner, closeLoadingSpinner } = this.props;
    openLoadingSpinner('Loading rental...');
    this.setState({ loading: true });
    this.fetchRental(id).then((response) => {
      let rental = response.data.rental;
      closeLoadingSpinner();
      this.fillNewRentalData(rental);
      this.setState({
        loading: false,
      });
    });
  };

  fetchRental = (id) => {
    return axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/api/portal/rentals/${id}/show_guest`
    );
  };

  updateRental = (data, onSuccess) => {
    const { openLoadingSpinner, closeLoadingSpinner } = this.props;
    openLoadingSpinner('Updating rental...');
    const params = objectToFormData({ rental: data });

    axios
      .patch(
        process.env.REACT_APP_API_DOMAIN +
          '/api/portal/rentals/' +
          this.props.rental.id,
        params
      )
      .then((response) => {
        let rental = response.data.rental;
        closeLoadingSpinner();
        this.fillNewRentalData(rental);
        if (onSuccess) {
          onSuccess(response);
        }
      })
      .catch((error) => {
        const errors = error.response.data;
        this.props.setErrors(errors);
      });
  };
  saveBeforeAttributes = () => {
    this.beforeAttributes = this.build_rails_object();
  };

  fillNewRentalData = (rental, overwriteStatus = true) => {
    const component = this;

    let nextItemId = component.state.last_item_id + 1;
    let ItemResult = prepopulateArray(
      nextItemId,
      rental.rentalItems,
      'rental_item'
    );
    nextItemId = ItemResult[1];
    let newItems = ItemResult[0];
    newItems = newItems.map((product) => {
      const rentalItem = product.rental_item;
      const rate = rentalItem.selectedPrice / rentalItem.quantity;
      const duration = 1;

      const newRentalItem = Object.assign(rentalItem, {
        duration: duration,
        selectedRate: rate,
      });
      product.rental_item = newRentalItem;
      return product;
    });

    let timeDiffhours;
    if (
      rental.schedule.eventStartDateTime &&
      rental.schedule.eventEndDateTime
    ) {
      const timeDiffms =
        new Date(rental.schedule.eventEndDateTime) -
        new Date(rental.schedule.eventStartDateTime);
      timeDiffhours = timeDiffms / 1000 / 60 / 60;
    } else {
      timeDiffhours = 0;
    }

    let newState = Object.assign(
      component.state,
      {
        hours: timeDiffhours,
        rental: rental,
        taxExempt: rental.taxExempt,
        depositRequired: rental.depositRequired,
        depositType: rental.depositType,
        expireType: rental.expireType,
        customExpireDate: rental.customExpireDate
          ? new Date(rental.customExpireDate)
          : null,
        signatureRequired: rental.signatureRequired,
        npsRequired: rental.npsRequired,
        hasAgreement: rental.hasAgreement,
        manualDamageWaiver: rental.manualDamageWaiver,
        damage_waiver_fee_total: rental.damageWaiverFeeTotal,
        items: newItems,
        last_item_id: nextItemId,
        sameAsEventDates: rental.schedule.sameAsEventDate,
        shouldRecalcDelivery: false,
        additionalOrderInfo: rental.additionalOrderInfo,
        additionalDeliveryInfo: rental.additionalDeliveryInfo,

        delivery_address_location_name:
          rental.deliveryAddressLocationName || '',
        delivery_address_street_address_1:
          rental.deliveryAddressStreetAddress1 || '',
        delivery_address_street_address_2:
          rental.deliveryAddressStreetAddress2 || '',
        delivery_address_city: rental.deliveryAddressCity || '',
        delivery_address_locale: rental.deliveryAddressLocale || '',
        delivery_address_postal_code: rental.deliveryAddressPostalCode || '',
        delivery_address_country: rental.deliveryAddressCountry || '',
      },
      overwriteStatus && { status: rental.status },
      rental.name && { name: rental.name },
      //Schedule

      rental.schedule.id && { schedule_id: rental.schedule.id },
      rental.schedule.startDate && {
        checkout: new Date(rental.schedule.startDate),
        start_date_time: new Date(rental.schedule.startDate),
      },
      rental.schedule.startTime && {
        checkout_time: new Date(rental.schedule.startTime),
      },
      rental.schedule.startWindowFinish && {
        checkoutWindowEnd: new Date(rental.schedule.startWindowFinish),
      },
      rental.schedule.endDate && {
        checkin: new Date(rental.schedule.endDate),
        end_date_time: new Date(rental.schedule.endDate),
      },
      rental.schedule.endTime && {
        checkin_time: new Date(rental.schedule.endTime),
      },
      rental.schedule.endWindowBeginning && {
        checkinWindowStart: new Date(rental.schedule.endWindowBeginning),
      },
      rental.schedule.eventStartDateTime && {
        event_start: new Date(rental.schedule.eventStartDateTime),
        event_start_time: new Date(rental.schedule.eventStartDateTime),
        event_start_date_time: new Date(rental.schedule.eventStartDateTime),
      },
      rental.schedule.eventEndDateTime && {
        event_end: new Date(rental.schedule.eventEndDateTime),
        event_end_time: new Date(rental.schedule.eventEndDateTime),
        event_end_date_time: new Date(rental.schedule.eventEndDateTime),
      },
      rental.deliveryCost && { delivery_cost: rental.deliveryCost },
      rental.deliveryType && { delivery_type: rental.deliveryType }
    );
    component.setState(newState, this.saveBeforeAttributes);
  };
  addDocument = (document) => {
    const data = {
      document_rental_relationships_attributes: {
        0: document,
      },
    };
    this.updateRental(data, (response) => {
      this.toggleDocumentModal();
    });
  };
  isOnlyLetters = (str) => {
    let strWithoutSpaces = str.replace(/\s/g, '');
    const res = /^[a-zA-Z]+$/.test(strWithoutSpaces);
    return res;
  };
  handleSubmitSignature = ({
    signature,
    signerName,
    signerTitle,
    signerCompany,
    disclaimerRentalRelationships,
  }) => {
    const {
      openLoadingSpinner,
      closeLoadingSpinner,
      openSuccessSnackBar,
      setErrors,
      rental,
    } = this.props;

    const disclaimersSignatures = getDisclaimersSignatures(
      disclaimerRentalRelationships
    );

    const rentalSignature = getSignatureFromRental(rental, 'customer');

    if (signature || disclaimersSignatures) {
      openLoadingSpinner('Submitting signature...');
      const data = {
        ...(signature !== null && {
          rental_signatures_attributes: [
            {
              id: rentalSignature?.id || null,
              signature: signature,
              signer_name: signerName,
              signer_title: signerTitle,
              signer_company: signerCompany,
              signature_type: 'customer',
            },
          ],
        }),
        disclaimerRentalRelationshipsAttributes: disclaimerRentalRelationships,
      };
      const params = objectToFormData({
        rental: converter.camelToSnakeCase(data),
      });
      axios
        .patch(
          `${process.env.REACT_APP_API_DOMAIN}/api/portal/rentals/${this.props.rental.token}/submit_signature`,
          params
        )
        .then((response) => {
          let { rental } = response.data;
          closeLoadingSpinner();
          this.fillNewRentalData(rental);
          this.toggleSignModal();
          openSuccessSnackBar('Sucessfully added signature');
        })
        .catch((error) => {
          console.log(error);
          const errors = error.response.data;
          setErrors(errors);
        });
    } else {
      setErrors('Signature cannot be blank or be only empty spaces.');
    }
  };

  build_rails_object = () => {
    const {
      items,
      schedule_id,
      start_date_time,
      end_date_time,
      checkoutWindowEnd,
      checkinWindowStart,
      event_start_date_time,
      event_end_date_time,
      sameAsEventDates,
      delivery_cost,
      delivery_type,

      delivery_address_location_name,
      delivery_address_street_address_1,
      delivery_address_street_address_2,
      delivery_address_city,
      delivery_address_locale,
      delivery_address_postal_code,
      delivery_address_country,
      damage_waiver_fee_total,
    } = this.state;
    const timeZone = moment.tz.guess();

    let rental = {
      active: true,
      delivery_cost: delivery_cost,
      delivery_type: delivery_type,
      delivery_address_location_name: delivery_address_location_name,
      delivery_address_street_address_1: delivery_address_street_address_1,
      delivery_address_street_address_2: delivery_address_street_address_2,
      delivery_address_city: delivery_address_city,
      delivery_address_locale: delivery_address_locale,
      delivery_address_postal_code: delivery_address_postal_code,
      delivery_address_country: delivery_address_country,
    };
    let schedule = Object.assign(
      {
        start_date_time: start_date_time,
        end_date_time: end_date_time,
        start_window_finish: checkoutWindowEnd,
        end_window_beginning: checkinWindowStart,
        event_start_date_time: event_start_date_time,
        event_end_date_time: event_end_date_time,
        same_as_event_date: sameAsEventDates,
        time_zone: timeZone,
      },
      schedule_id && { id: schedule_id }
    );

    const rental_item_standards = items.filter(
      (item) => item.rental_item.type === 'RentalItemStandard'
    );
    let formatted_rental_item_standards = nestedStateForRailsWithConversion(
      rental_item_standards.slice(),
      'rental_item'
    );

    /*eslint-disable */
    rental = Object.assign(rental, {
      damage_waiver_fee_total: damage_waiver_fee_total,
      schedule_attributes: schedule,
      rental_item_standards_attributes: formatted_rental_item_standards,
    });
    return rental;
  };

  handleDeliveryChangeSubmit = (state) => {
    const {
      deliveryType,
      deliveryAddressLocationName,
      deliveryAddressStreetAddress1,
      deliveryAddressStreetAddress2,
      deliveryAddressCity,
      deliveryAddressLocale,
      deliveryAddressPostalCode,
      deliveryAddressCountry,
      checkout,
      checkoutWindowEnd,
      checkoutTime,
      checkin,
      checkinWindowStart,
      checkinTime,
      sameAsEventDates,
    } = state;

    const newState = Object.assign(
      {
        start_date_time: checkout,
        end_date_time: checkin,
        checkout,
        checkoutWindowEnd,
        checkout_time: checkout,
        checkin,
        checkinWindowStart,
        checkin_time: checkin,
        sameAsEventDates,
        delivery_type: deliveryType,
        delivery_address_location_name: deliveryAddressLocationName,
        delivery_address_street_address_1: deliveryAddressStreetAddress1,
        delivery_address_street_address_2: deliveryAddressStreetAddress2,
        delivery_address_city: deliveryAddressCity,
        delivery_address_locale: deliveryAddressLocale,
        delivery_address_postal_code: deliveryAddressPostalCode,
        delivery_address_country: deliveryAddressCountry,
        canLeave: false,
      },
      deliveryType === 'customer_pick_up' && { deliveryCost: 0 }
    );
    this.setState(newState);
  };

  adjustRentalItems = (rentalItem, index) => {
    let items = this.state.items.slice();
    if (rentalItem.quantity === '') {
      rentalItem.quantity = 0;
    }
    const newRentalItem = Object.assign(items[index].rental_item, {
      ...rentalItem,
    });
    items[index].rental_item = newRentalItem;
    this.setState({
      items: items,
      canLeave: false,
    });
  };

  deleteRentalItem = (index) => {
    let items = this.state.items.slice();
    items[index].rental_item = Object.assign(items[index].rental_item, {
      _destroy: '1',
    });
    this.setState({
      items: items,
      canLeave: false,
    });
  };

  renderSelectItem = (item) => {
    return <div>{item.locationName}</div>;
  };

  toggleCancelModal = () => {
    this.setState({
      cancelModalOpen: !this.state.cancelModalOpen,
    });
  };

  togglePayment = () => {
    this.setState({
      paymentOpen: !this.state.paymentOpen,
    });
  };

  toggleDocumentModal = () => {
    this.setState({
      documentModalOpen: !this.state.documentModalOpen,
    });
  };

  toggleSignModal = () => {
    this.setState({
      signModalOpen: !this.state.signModalOpen,
    });
  };

  toggleSuccessOpen = () => {
    this.setState({
      successOpen: !this.state.successOpen,
    });
  };

  handlePaymentSuccess = (transaction) => {
    this.togglePayment();
    this.refreshRental();
    this.setState({ successTransaction: transaction, successOpen: true });
  };

  render() {
    const { rental, loading } = this.state;
    const { customer, location, visible } = this.props;
    const {
      canLeave,
      cancelModalOpen,
      successOpen,
      successTransaction,
    } = this.state;

    if (loading || !rental.id) {
      return <LoadingSpinner />;
    } else {
      return (
        <div
          className={classNames({
            rental: true,
            guestCheckout: true,
            guestCheckoutHidden: !visible,
          })}
        >
          <Rental
            rental={rental}
            location={location}
            customer={customer}
            fields={this.state}
            onDeliveryChangeSubmit={this.handleDeliveryChangeSubmit}
            adjustRentalItems={this.adjustRentalItems}
            deleteRentalItem={this.deleteRentalItem}
            addDocument={this.addDocument}
            onSubmitSignature={this.handleSubmitSignature}
            refreshRental={this.refreshRental}
            togglePayment={this.togglePayment}
            toggleDocumentModal={this.toggleDocumentModal}
            toggleSignModal={this.toggleSignModal}
            onPaymentSuccess={this.handlePaymentSuccess}
          />
          <Modal
            open={successOpen}
            toggle={this.toggleSuccessOpen}
            title='Payment Confirmation'
            actions={[
              <a
                key='successOpen'
                className='btn full'
                onClick={this.toggleSuccessOpen}
              >
                Ok
              </a>,
            ]}
          >
            <div>
              <p>
                Thanks for your payment of{' '}
                <strong>
                  <CurrencyLabel value={successTransaction.amount} />
                </strong>
              </p>
              <p>
                <FormattedDate
                  value={successTransaction.createdAt}
                  year='numeric'
                  month='numeric'
                  day='numeric'
                  hour='numeric'
                  minute='numeric'
                />
              </p>
              <p>Confirmation #{successTransaction.token}</p>
            </div>
          </Modal>
        </div>
      );
    }
  }
}

export default connect(null, actions)(GuestCheckout);
